(function () {
  var ALIASES = {
    hackfleisch: ['hackfleisch', 'hack', 'gehacktes'],
    hack: ['hack', 'hackfleisch', 'gehacktes'],
    airfryer: ['airfryer', 'heissluftfritteuse'],
    heissluftfritteuse: ['heissluftfritteuse', 'airfryer'],
    ofen: ['ofen', 'backofen'],
    backofen: ['backofen', 'ofen']
  };

  var PRODUCT_STOP_WORDS = {
    hof: 1, rind: 1, rinder: 1, schwein: 1, schweine: 1, beef: 1, fleisch: 1, weidrind: 1,
    vom: 1, von: 1, der: 1, die: 1, das: 1, den: 1, dem: 1, des: 1,
    aus: 1, am: 1, im: 1, in: 1, mit: 1, und: 1, oder: 1, fuer: 1,
    ca: 1, gramm: 1, kilo: 1, kg: 1, paket: 1, bundle: 1, lecker: 1,
    mariniert: 1, natur: 1, style: 1, zum: 1, satt: 1, essen: 1, pure: 1,
    freude: 1, bestes: 1, beste: 1, bester: 1, klassisch: 1, frisch: 1,
    frische: 1, frischer: 1, hier: 1, unsere: 1, unser: 1, original: 1,
    gross: 1, grosse: 1, kleine: 1, kleiner: 1, stueck: 1, cut: 1
  };

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function hit(source, query) {
    var aliases = ALIASES[query] || [query];
    var words = (source || '').split(' ');
    return aliases.some(function (alias) {
      return words.some(function (word) {
        if (query === 'leber' && (word === 'leberkase' || word === 'leberkaese')) return false;
        return word === alias || (alias.length >= 4 && (word.indexOf(alias) === 0 || word.slice(-alias.length) === alias));
      });
    });
  }

  function dish(item, query) {
    var title = normalize(item.t);
    var search = item.s || '';
    if ((item.d || []).indexOf(query) > -1) return true;
    if (query === 'salat') return /(^| )(salat|kartoffelsalat|wurstsalat|nudelsalat|fleischsalat)( |$)/.test(title);
    if (query === 'pizza') return hit(title, 'pizza');
    if (query === 'burger') return hit(title, 'burger') || hit(search, 'burger');
    if (query === 'pasta') return hit(title, 'pasta') || hit(title, 'nudeln') || hit(title, 'spaghetti') || hit(title, 'penne') || hit(title, 'tagliatelle');
    if (query === 'bolognese') return hit(title, 'bolognese');
    if (query === 'gulasch') return hit(title, 'gulasch');
    return false;
  }

  function productTerms(handle, label) {
    var raw = normalize((label || '') + ' ' + String(handle || '').replace(/-/g, ' '));
    var terms = [];
    var seen = Object.create(null);

    raw.split(' ').forEach(function (token) {
      if (!token || token.length < 4 || PRODUCT_STOP_WORDS[token] || /^\d+$/.test(token)) return;
      if (!seen[token]) {
        seen[token] = true;
        terms.push(token);
      }

      var alias = '';
      if (token.indexOf('rinder') === 0 && token.length > 8) alias = token.slice(6);
      if (token.indexOf('schweine') === 0 && token.length > 10) alias = token.slice(8);
      if (alias && alias.length >= 5 && !PRODUCT_STOP_WORDS[alias] && !seen[alias]) {
        seen[alias] = true;
        terms.push(alias);
      }
    });

    terms.sort(function (a, b) { return b.length - a.length; });
    return terms.slice(0, 8);
  }

  function productSpecies(handle, label) {
    var raw = normalize((label || '') + ' ' + String(handle || '').replace(/-/g, ' '));
    if (/(rind|beef|weidrind|ochs|bulle|kalb)/.test(raw)) return 'rind';
    if (/(schwein|pork)/.test(raw)) return 'schwein';
    if (/(hahnchen|huhn|pute|geflugel|chicken|turkey)/.test(raw)) return 'geflugel';
    return '';
  }

  function speciesMatch(item, species) {
    if (!species) return true;
    var blob = normalize([item.t, item.s, item.i].join(' '));
    if (species === 'rind') return /(rind|beef|ochs|bulle|kalb)/.test(blob);
    if (species === 'schwein') return /(schwein|pork)/.test(blob);
    if (species === 'geflugel') return /(hahnchen|huhn|pute|geflugel|chicken|turkey)/.test(blob);
    return true;
  }

  function productMatch(item, terms, species) {
    if (!speciesMatch(item, species)) return false;
    var blob = normalize([item.t, item.s, item.i].join(' '));
    return terms.some(function (term) { return hit(blob, term); });
  }

  function productScore(item, terms) {
    var blob = normalize([item.t, item.s, item.i].join(' '));
    var score = item.k === 'r' ? 3 : 0;
    terms.forEach(function (term, index) {
      if (hit(blob, term)) score += Math.max(2, 12 - index) + (term.length >= 8 ? 3 : 0);
    });
    return score;
  }

  function boot() {
    document.querySelectorAll('[data-dlm-rs3]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';

      var form = root.querySelector('[data-rs3-form]');
      var input = root.querySelector('[data-rs3-input]');
      var methodSelect = root.querySelector('[data-rs3-method]');
      var status = root.querySelector('[data-rs3-status]');
      var output = root.querySelector('[data-rs3-results]');
      var more = root.querySelector('[data-rs3-more]');
      var clear = root.querySelector('[data-rs3-clear]');
      var blog = document.querySelector('.main-blog');
      var data = null;
      var pending = null;
      var rows = [];
      var shown = 0;
      var timer = null;

      var params = new URLSearchParams(window.location.search);
      var productHandle = params.get('product') || '';
      var productLabel = params.get('product_label') || '';
      var activeProductTerms = productTerms(productHandle, productLabel);
      var activeProductSpecies = productSpecies(productHandle, productLabel);
      var productMode = Boolean(productHandle && activeProductTerms.length);

      function load() {
        if (data) return Promise.resolve(data);
        if (pending) return pending;
        status.textContent = 'Rezepte werden geladen …';
        pending = fetch(root.dataset.indexUrl, { cache: 'force-cache' })
          .then(function (response) {
            if (!response.ok) throw Error();
            return response.json();
          })
          .then(function (payload) {
            data = payload.items || [];
            return data;
          })
          .catch(function () {
            status.textContent = 'Die Suche konnte nicht geladen werden.';
            return [];
          });
        return pending;
      }

      function card(item) {
        var image = item.im ? (item.im.indexOf('//') === 0 ? 'https:' + item.im : item.im) : '';
        return '<a class="dlm-rs3__card" href="' + escapeHtml(item.u) + '">' +
          (image ? '<span class="dlm-rs3__media"><img src="' + escapeHtml(image + (image.indexOf('?') > -1 ? '&' : '?') + 'width=360') + '" alt="' + escapeHtml(item.a || item.t) + '" loading="lazy" decoding="async"></span>' : '<span class="dlm-rs3__media"></span>') +
          '<span class="dlm-rs3__body"><strong class="dlm-rs3__title">' + escapeHtml(item.t) + '</strong></span></a>';
      }

      function render(reset) {
        if (reset) {
          shown = 0;
          output.innerHTML = '';
        }
        var chunk = rows.slice(shown, shown + 18);
        if (chunk.length) output.insertAdjacentHTML('beforeend', chunk.map(card).join(''));
        shown += chunk.length;
        more.hidden = shown >= rows.length;
      }

      function run() {
        var query = normalize(input.value);
        var method = methodSelect.value;

        if (!productMode && query.replace(/\s/g, '') === 'streifenfleisch') {
          clear.hidden = false;
          if (blog) blog.hidden = true;
          output.innerHTML = '';
          rows = [];
          shown = 0;
          more.hidden = true;
          status.textContent = 'Keine passenden Rezepte gefunden.';
          return;
        }

        if (!productMode && !query && !method) {
          output.innerHTML = '';
          status.textContent = '';
          more.hidden = true;
          clear.hidden = true;
          if (blog) blog.hidden = false;
          return;
        }

        clear.hidden = false;
        if (blog) blog.hidden = true;

        load().then(function () {
          rows = data.filter(function (item) {
            var blocked = normalize([item.t, item.s, item.i].join(' '));
            if (blocked.indexOf('streifenfleisch') > -1) return false;

            if (method) {
              var methods = item.m || [];
              if (method === 'backofen') {
                if (methods.indexOf('backofen') < 0 && methods.indexOf('airfryer') < 0) return false;
              } else if (methods.indexOf(method) < 0) {
                return false;
              }
            }

            if (productMode) return productMatch(item, activeProductTerms, activeProductSpecies);
            if (!query) return true;
            if (query === 'streifenfleisch') return false;
            if (query === 'hackfleisch' || query === 'hack') {
              return hit(item.i, 'hackfleisch') || hit(normalize(item.t), 'hackfleisch') || hit(item.i, 'hack') || hit(normalize(item.t), 'hack');
            }
            if (['salat', 'pasta', 'pizza', 'burger', 'bolognese', 'gulasch'].indexOf(query) > -1) return dish(item, query);
            return query.split(' ').every(function (term) {
              return hit(item.i, term) || hit(normalize(item.t), term);
            });
          });

          var seenTitles = Object.create(null);
          rows = rows.filter(function (item) {
            var key = normalize(item.t);
            if (!key) return true;
            if (seenTitles[key]) return false;
            seenTitles[key] = true;
            return true;
          });

          if (productMode) {
            rows.sort(function (a, b) {
              return productScore(b, activeProductTerms) - productScore(a, activeProductTerms) || normalize(a.t).localeCompare(normalize(b.t), 'de');
            });
          } else {
            rows.sort(function (a, b) {
              var aTitle = normalize(a.t);
              var bTitle = normalize(b.t);
              var aStarts = aTitle.indexOf(query) > -1 ? 1 : 0;
              var bStarts = bTitle.indexOf(query) > -1 ? 1 : 0;
              return bStarts - aStarts || aTitle.localeCompare(bTitle, 'de');
            });
          }

          if (productMode) {
            var label = productLabel || input.value || 'dieses Produkt';
            status.textContent = rows.length === 1
              ? '1 passendes Rezept für ' + label + ' gefunden'
              : rows.length + ' passende Rezepte für ' + label + ' gefunden';
          } else {
            status.textContent = rows.length === 1 ? '1 passendes Rezept gefunden' : rows.length + ' passende Rezepte gefunden';
          }

          if (!rows.length) status.textContent = 'Keine passenden Rezepte gefunden.';
          render(true);
        });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        run();
      });

      input.addEventListener('input', function () {
        productMode = false;
        clearTimeout(timer);
        timer = setTimeout(run, 140);
      });

      methodSelect.addEventListener('change', run);

      root.querySelectorAll('[data-rs3-query]').forEach(function (button) {
        button.addEventListener('click', function () {
          productMode = false;
          input.value = button.dataset.rs3Query;
          run();
        });
      });

      clear.addEventListener('click', function () {
        productMode = false;
        input.value = '';
        methodSelect.value = '';
        run();
        input.focus();
      });

      more.addEventListener('click', function () { render(false); });

      if (productMode) {
        input.value = productLabel || productHandle.replace(/-/g, ' ');
        run();
      } else {
        var initialQuery = params.get('q');
        if (initialQuery) {
          input.value = initialQuery;
          run();
        }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
